import { ResourceData } from './../../elements/resource/resource.types';
import { SCALE } from './canvas.types';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Point } from '../../elements/base/point';
import 'rxjs/add/operator/toPromise';
import { Resource } from '../../elements/resource/resource';
import { ResourceIRI } from '../../elements/resource/resource.types';
import { Time, Animation } from '../animation/animation.types';
import { SCALE_IN, ShapeAlias } from './canvas.types';
import {
  ComponentType,
  ComponentEvent,
} from '../../components/general-component/general.component.type';
import {
  ConstraintEntity,
  ControlPointDefinition,
  Coords,
  FileDescriptor,
  GeneralShapeDescriptor,
  PathShapeDescriptor,
  ShapeSelectParams,
} from '../../elements/resource/types/shape.type';
import {
  lookup_scale_in,
  lookup_scale_out,
} from './../util/scale/scale_lookup';
import { ImageDescriptor } from '../../elements/resource/types/shape.type';
import { Subject } from 'rxjs';
import { cloneDeep, toNumber } from 'lodash';
import { GeneralShape } from '../../element-editor/shape/shapes/general/general-shape';

import { PathShape } from '../../element-editor/shape/shapes/path-shape/path-shape';
import {
  AnimationFrame,
  SoundAnimationFrame,
} from '../../element-editor/animation/components/animation-frame/animation.types';
import { AnimationFrameObject } from '../../element-editor/animation/frame/animation-frame-object';
import { RootAnimationFrame } from '../../element-editor/animation/frame/main-animation-frame-object';
import { PathSection } from '../../element-editor/shape/shapes/path-shape/path-sections/path-section';
import { ImportedShape } from '../../element-editor/shape/shapes/general/imported/imported-shape';
import { GeneralSelectorConfig } from '../../components/util/general-selector/general-selector.component';
import { RootShape } from '../../element-editor/shape/shapes/general/root/root-shape';
import { Application, Container, Graphics } from 'pixi.js';
import { MetascriptService } from '../../ms/metascript.service';
import { SVG } from '../../element-editor/shape/shapes/primitive/svg-element';
import { environment } from '../../../environments/environment';
import { RectangleController } from '../../elements/util/rectangle-controller/rectangle-controller';
import { PointController } from '../../elements/util/point-controller/point-controller';
import { Store } from '@ngrx/store';
import {
  saveResourcesAction,
  setFontLoaded,
  setOverlay,
} from '../../element-editor/store/editor.actions';
import { setMainAnimationFrame } from '../../element-editor/animation/store/animation.actions';
import { HttpService } from '../../store/http/http.service';
import { RectangleElement } from '../../element-editor/shape/shapes/primitive/rectangle-element';
import { RightClickMenu } from '../../element-editor/right-click-menu/right-click-menu.component';
import { Router } from '@angular/router';
import WebFont from 'webfontloader';
import {
  selectChangeTookPlace,
  selectCurrentBackgroundId,
} from '../../element-editor/store/selector/editor.selector';
import { CrudEvents } from '../../element-editor/store/reducer/editor.reducer';
import { debounceTime } from 'rxjs/operators';
import { descriptorMapTest } from '../../projects/project.actions';
import { BackgroundService } from '../../element-editor/store/studio/background/background.service';
import { FileRootShape } from '../../element-editor/shape/shapes/general/root/file-root-shape';
import { IRIToId } from '../../util/iri';
import { SceneTransition } from '../../element-editor/animation/text-animation.service';
import gsap from 'gsap';
import {
  deselectAllShapes,
  selectIsPortraitMode,
  setCurrentStudioSceneIndex,
  setPanelStable,
} from '../../element-editor/store/studio';
export const [screenX, screenY] = [1420, 810];
export const [_screenX, _screenY] = [1216, 684];
// export const [_screenX, _screenY] = [1080, 1350];
export const [portraitScreenX, portraitScreenY] = [1080, 1350];
export const [screenXOffset, screenYOffset] = [0, 0];

export const BASE_BLUE = '#0191f3';

export enum DataEditorState {
  Animation = 'animation',
  Label = 'label',
}

export interface Action {
  id: string;
  prev: Action;
  next?: Action;
}

export interface APIResponse<T = any> {
  data?: T;
  error?: any;
}

export type ConnectionTypes = 'parent' | 'child' | 'prev' | 'next';

export interface AnimationPatch {
  type: 'post' | 'patch' | 'delete';
  id: string;
  frame?: AnimationFrame;
  connection?: ConnectionTypes;
}

export interface SingleAnimation {
  shapeAlias: ShapeAlias;
  shapeGroup: string;
  animation: Animation;
}

// const UNSAVED_IMAGE_KEY = 'UNSAVED_IMAGE_KEY'; //

export const INITIAL_PATCH_KEY = '0';
const INITIAL_DIMENSION = {
  scale: 1,
  x: 0,
  y: 0,
};

@Injectable()
export class CanvasService {
  get _screenX() {
    return _screenX;
  }

  get _screenY() {
    return _screenY;
  }

  get portraitScreenX() {
    return 1080;
  }

  get portraitScreenY() {
    return 1350;
  }

  app: Application = new Application({
    autoDensity: true,
    resolution: window.devicePixelRatio || 1,
    antialias: true,
    backgroundAlpha: 0,
    // backgroundColor: '#ff0000',
    // width: _screenX,
    // height: _screenY,
    // width: 1600,
    // height: 1600,
    // res
    width: 0,
    height: 0,
  });
  canvasNativeElement: HTMLDivElement;
  canvas: any;
  screenWidth = 1420;
  screenHeight = 810;
  previewApp: Application = new Application({
    autoDensity: true,
    resolution: 2,
    antialias: true,
    backgroundColor: '#ffffff',
  });
  /********** ACTION ***********/

  urlQueryParams: {
    state?: string;
  } = {};

  canvasOverlayConfig: 'image-selector' | 'image-prompt';

  rightClickMenu: RightClickMenu;

  debug: Record<string, any> = {};

  studioMode = false;
  isPortrait = false;

  hoveredPC: PointController;

  logs: Record<string, EventEmitter<string>> = {};

  orientationLimit = 6;

  pendingPatches: Record<string, PathShapeDescriptor> = {};
  snapShots: Record<string, PathShapeDescriptor>[] = [];

  elements: Record<string, GeneralShapeDescriptor> = {};
  IRIs: Record<string, string> = {};
  animationAssignments: {
    shape: ShapeAlias;
    animation: string;
  }[] = [];

  shapeGroups: Record<string, ResourceIRI[]> = {};
  started: Time;
  shiftTime: Time;

  /************ CURSOR *************/
  currentCursorPoint: Point;

  // originOffset: PointData = { x: 0, y: 0 };

  pathShapeExtendMode: 'line' | 'curve' | 'anchor-curve' = 'line';

  /********** STATES ***********/

  tmpPosition: {
    x: number;
    y: number;
    scale: {
      x: number;
      y: number;
    };
  };

  alt = false;

  frameToBeMoved?: AnimationFrameObject;
  animationFrameMoveMode: 'set-frame-to-be-moved' | 'set-prev' | 'move-up';

  setAnimationFrameMoveMode(
    mode: 'set-frame-to-be-moved' | 'set-prev' | 'move-up',
  ) {
    // -- // -- //
    this.animationFrameMoveMode = mode;
  }

  dataEditorState: DataEditorState;
  dataEditorType: string;
  disabled = false;
  dragState = false;
  loading = false;
  shift = false;
  unsavedImage = false;
  toSave = false;
  showAnimationPanel = true;
  shapeStore: Record<string, Record<string, ResourceIRI>> = {};
  shapeAlias: Record<ShapeAlias, ResourceIRI> = {};

  /********** STORE ***********/
  animations: Record<string, Animation> = {};
  animationSuscribers = {};
  // shapeRegistry: Record<string, > = {};
  resourceStore: Record<string, Resource> = {};
  loadedShapes: Record<string, boolean> = {};
  newImageName: string;

  @Output() componentCall: EventEmitter<ComponentEvent> =
    new EventEmitter<ComponentEvent>();

  animationInterval: number;
  animationTick = new Subject<number>();
  lastAnimationStarted: number;
  componentMessager = new Subject<{ target: string; message: any }>();
  scaler = new Subject<{ x: number; y: number; scale: number }>();
  mouseMove = new Subject<{ x: number; y: number }>();
  clickEvent = new Subject<string>();
  // generalEvent = new Subject<any>();
  generalEvents: Record<string, Subject<unknown>> = {};

  pressedKeys: Record<string, number> = {};

  // scaleValue = INITIAL_SCALE_VALUE;

  circle: any;

  canvasOffset: { x: number; y: number } = { x: 0, y: 0 };

  clickDisabled = false;

  customShapeToDrag: GeneralShape;

  _previewShape: RootShape;

  hoveredSection: PathSection;
  hoveredPoint: PathSection;

  hoveredControlPoint: ControlPointDefinition;
  draggedPointController: PointController;
  _hoveredControlPoint: PointController;

  pathSections: Record<string, PathSection> = {};

  copiedShapes: GeneralShape[];
  copiedAnimation: AnimationFrame;

  copiedFunction: {
    name: string;
    frame: AnimationFrame;
  };

  blinkIRI: string;

  logShapes: string[] = [];

  _canvasScale = 1;

  get canvasScale() {
    return this._canvasScale;
  }

  get _canvasWidth() {
    return _screenX;
  }

  get _canvasHeight() {
    return _screenY;
  }

  set canvasScale(val: number) {
    this._canvasScale = val;
  }

  previewShapesByScene: Record<string, RootShape> = {};
  currentShape: RootShape;

  set previewShape(rootShape: RootShape) {
    // this.previewShapesByScene[this.currentScene || 'main'] = rootShape;
    this.currentShape = rootShape;
  }

  get previewShape() {
    return this.currentShape;
  }

  get fileRootShape() {
    return this.currentShape as FileRootShape;
  }

  get currentStates() {
    return this.previewShape?.descriptor.states || [];
  }

  get currentState() {
    return this.previewShape?.currentState;
  }

  set currentState(val: string) {
    console.log('set-current-state', val);
    this.previewShape.currentState = val;
  }

  get debugEntries() {
    return Object.entries(this.debug);
  }

  get currentResources() {
    return Object.values(this.resourceStore || {}) as GeneralShape[];
  }

  get onlyOneSelected() {
    return this.selectedShapes?.length === 1;
  }

  get selectedTrajectoryShapes() {
    return this.selectedShapes.filter(shape => shape.getType() === 'ts');
  }

  get isShiftPressed() {
    return this.isPressed('Shift');
  }

  get isAlPressed() {
    return this.isPressed('Alt');
  }

  get isMetaPressed() {
    return this.isPressed('Meta');
  }

  get currentFunctions() {
    return (
      this.previewShape?.animationFrame?.frame.functions?.map(
        ({ name }) => name,
      ) || []
    );
  }

  get currentScreenX() {
    return this.isPortrait ? this.portraitScreenX : this._screenX;
  }

  get currentScreenY() {
    return this.isPortrait ? this.portraitScreenY : this._screenY;
  }

  xs: number;
  ye: number;
  xMax: number;
  yMax: number;
  isImageProcessingMode = false;

  startAction() {
    const current = {
      id: Math.random().toString(),
      prev: this.current,
    };

    if (this.current) {
      this.current.next = current;
    }
    this.current = current;
  }

  current: Action;
  endAction() {
    // -- //
  }
  getXCoord(x: number) {
    return x - this.xs;
  }

  getYCoord(y: number) {
    return this.ye - y;
  }

  rotateMode = false;
  start: number;
  sum = 0;

  deltas: number[] = [];

  mode: 'none' | 'edit' | 'image' = 'none';
  projectIRI: string;
  loadedItem?: string;
  loadedState?: string;
  currentStateName: string;
  pathShapeSelectMode = false;
  playOnlyTillNextStage = true;
  currentScene: string;
  currentProjectID: string;
  get currentFileID() {
    return IRIToId(this.currentRootShape?.IRI);
  }

  get currentFileIRI() {
    return this.currentRootShape?.IRI;
  }

  currentRootFileID: string;
  currentAnimationID: string;
  loadedFileID: string;
  currentOrganisationID: string;
  bgRectangle: Graphics;
  currentCrudEvents: CrudEvents = {
    patches: {},
    posts: {},
    deletes: {},
  };
  saveTimeout: NodeJS.Timeout;
  changeTookPlace: number;

  setBgColor(color: string) {
    // this.app.renderer.background.color = convertHexToNumber(color); //
    // console.log('----------- set-bg-color ------------', color); //
    if (!this.previewShape) {
      return;
    }
    this.previewShape.rect.patch({
      fill: color,
    });

    // console.log('setting-bg-color', '#072037'); //
    // this.bgRectangle.beginFill(convertHexToNumber(color)); //
    // this.bgRectangle.drawRect(-1000, -1000, 2000, 2000); //
    // this.bgRectangle.endFill(); // -- 66
  }

  isPortraitMode$ = this.store.select(selectIsPortraitMode);
  private autoSaveSubject = new Subject<void>();
  constructor(
    // TODO - move it to http&
    readonly msService: MetascriptService,
    public router: Router,
    readonly store?: Store,
    // This is used by the image shape
    readonly httpService?: HttpService,
    readonly backgroundService?: BackgroundService,
  ) {
    this.store.select(selectCurrentBackgroundId).subscribe(id => {
      // console.log('selectCurrentBackgroundId', id); // -- //
      if (!id || !this.previewShape) {
        return;
      }
      this.backgroundService.setById(id);

      this.setThumbnail(
        this.previewShape.IRI,
        this.backgroundService.container,
      );
      // -- // this.cs.setThumbnail(this.cs.previewShape.IRI, this.thumbnailContainer); // -- //
    });

    if (WebFont) {
      // -- // -- //
      WebFont?.load({
        google: {
          // families: ['Goldman:400,700'], // Specify weights 400 (regular) and 700 (bold)
          families: ['Inter:100,200,300,400,500,600,700,800,900'],
          // families: ['Work Sans:300,400,700'],
          // families: ['Lalezar'], // Only one weight is available for Lalezar
        },
        active: e => {
          this.store.dispatch(setFontLoaded({ value: true }));
          // console.log('font loaded!');
          // now start setting up your PixiJS (or canvas) stuff! //
        },
      });
    }

    this.rootFixContainer = new Container();
    this.rootContainer = new Container();
    this.canvasContainer = new Container();
    this.canvasBackgroundContainer = new Container();

    // this.canvasContainer.addChild(this.backgroundService.container);
    this.autoSaveSubject
      .pipe(debounceTime(3000)) // wait 3 seconds after the last event
      .subscribe(() => {
        this.patchFiles();
        // this.setThumbnail(this.currentAnimationID);
      });

    // this.bgRectangle = new Graphics();
    // this.bgRectangle.beginFill(16777215);
    // this.bgRectangle.drawRect(-1000, -1000, 6000, 6000);
    // this.bgRectangle.endFill();
    // this.bgRectangle.interactive = true;
    // this.bgRectangle.on('mouseover', () => {
    //   // console.log('cs-container > mouseover');
    //   this.generalEventEmit('canvas-hover');
    // });
    // this.bgRectangle.on('mouseout', () => {
    //   console.log('cs-container > mouseout');
    // }
    // this.app.stage.addChild(this.bgRectangle);

    // this.app.renderer.background.color = 0x072037;
    // this.app.renderer.background.color = '#072037';
    // this.app.renderer.background.color = 0x072037;

    this.rootContainer.addChild(this.canvasBackgroundContainer);
    this.rootContainer.addChild(this.canvasContainer);
    this.rootContainer.addChild(this.canvasCircleContainer);

    // this.rootContainer.position.y = _screenY / 4;

    this.app.stage.addChild(this.rootContainer);

    // -- // this.canvasContainer.position.y = 81; // -- //
    this.app.view.style.cursor = 'default';

    // -- // -- // -- //
    // this.app.renderer.plugins.interaction.cursorStyles.pointer = 'default'; // Set default cursor for pointer interactions
    // Or any cursor style you prefer //

    // WebFont.load({
    //   google: {
    //     families: ['Inter:300,400,500, 600,700'],
    //   },
    //   active: e => {
    //     this.store.dispatch(setFontLoaded({ value: true }));
    //     // now start setting up your PixiJS (or canvas) stuff!
    //   },
    // });

    this.store.select(selectChangeTookPlace).subscribe(changeTookPlace => {
      // -- // -- //
      // console.log('changeTookPlace', changeTookPlace, this.changeTookPlace); // -- //
      if (this.changeTookPlace !== changeTookPlace) {
        this.changeTookPlace = changeTookPlace;
        this.autoSaveSubject.next();
      }
    });

    // this.store.select(selectCrudEvents).subscribe(crudEvents => {
    //   // -- // -- //
    //   if (!isEqual(this.currentCrudEvents, crudEvents)) {
    //     clearTimeout(this.saveTimeout);
    //     console.log('clearTimeout - start wait...');
    //     this.saveTimeout = setTimeout(() => {
    //       this.patchFiles();
    //       this.saveThumbnail();
    //       console.log('save');
    //       this.currentCrudEvents = {
    //         posts: {},
    //         patches: {},
    //         deletes: {},
    //       };
    //     }, 2_000);
    //   }
    //   this.currentCrudEvents = crudEvents;
    // });

    if (!environment.production) {
      globalThis.__PIXI_APP__ = this.app;
    }

    this.keyDownEventSubscribe('g', () => {
      if (this.tmpPosition) {
        const { x, y, scale } = this.tmpPosition;

        this.previewShape.rootContainer.setTransform(x, y, scale.x, scale.y);
        return;
      }

      this.tmpPosition = {
        x: this.previewShape.translateX,
        y: this.previewShape.translateY,
        scale: {
          x: this.previewShape._scaleX,
          y: this.previewShape._scaleY,
        },
      };
    });

    const changeShapeAddMode = (mode: typeof this.shapeAddMode) => {
      this.shapeAddMode = this.shapeAddMode === mode ? null : mode;
      this.generalEventEmit('shape-add-mode-changed');
    };

    this.generalEventSubscribe('globalClick', () => {
      // -- // this.overlayResponse(); // -- //
      // console.log('cs > globalClick');
      this.store.dispatch(setOverlay({ value: null }));
    });

    this.keyDownEventSubscribe('r', () => changeShapeAddMode('rectangle'), 100);
    this.keyEventSubscribe('t', () => changeShapeAddMode('text'), 100);
    this.keyEventSubscribe('g', () => changeShapeAddMode('glow'), 100);
    this.keyEventSubscribe('e', () => changeShapeAddMode('circle'), 100);
    this.keyEventSubscribe('c', () => changeShapeAddMode('comment'), 100);
    this.keyEventSubscribe('w', () => changeShapeAddMode('path'), 10);

    // -- // -- //
    this.keyEventSubscribe(
      'd+f',
      () => this.store.dispatch(descriptorMapTest()),
      10,
    );

    this.keyDownEventSubscribe('AltLeft', () => {
      this.previewShape?.shapes.map(shape => shape.deselect({ onHover: true }));
    });

    this.keyDownEventSubscribe('Alt', () => {
      this.previewShape?.shapes.map(shape => shape.deselect({ onHover: true }));
    });

    this.keyEventSubscribe('Escape', () => (this.shapeAddMode = null));
    this.keyEventSubscribe(
      'a',
      () => {
        if (!this.isShiftPressed) {
          this.previewShape?.setPreAnimationState();
        }
      },
      100,
    );

    this.keyEventSubscribe('--Shift+s', () => {
      // todo implmeent
    });

    this.keyEventSubscribe('Shift+f', () => {
      // todo - implement
    });

    // Do not remove
    this.currentCursorPoint = new Point(0, 0);

    // this.keyEventSubscribe('v', () => {
    //   if (this.copiedFunction) {
    //     const { name, frame } = this.copiedFunction;
    //     this.mainFrame.addFunction(name, frame);
    //     this.mainFrame.save();
    //     this.notify('Function has been pasted!');
    //   }
    // });

    this.keyEventSubscribe('Escape', () => {
      this.shapeAddMode = null;
      if (this.generalSelectorConfigEnabled) {
        this.generalSelectorConfigEnabled = false;
        this.generalSelectorCallback = () => null;
      }
    });

    this.keyEventSubscribe('s+a', () => {
      console.log('s+a');
      this.previewShape?.shapes.map(shape => shape.show());
    });

    this.keyEventSubscribe('v+ArrowLeft', () => {
      this.selectedShapes.map(shape => {
        shape.completeDrag(-5 / this.canvasScale, 0);
      });
    });

    this.keyEventSubscribe('v+ArrowRight', () => {
      this.selectedShapes.map(shape => {
        shape.completeDrag(5 / this.canvasScale, 0);
      });
    });

    this.keyEventSubscribe('v+ArrowUp', () => {
      this.selectedShapes.map(shape => {
        shape.completeDrag(0, -5 / this.canvasScale);
      });
    });

    this.keyEventSubscribe('v+ArrowDown', () => {
      this.selectedShapes.map(shape => {
        shape.completeDrag(0, 5 / this.canvasScale);
      });
    });

    this.keyEventSubscribe('x', () => this.flipAuxMode());

    // this.keyEventSubscribe('Shift+O', () => this.defineInputs());
    // this.keyEventSubscribe('l', () => {
    //   console.log('------ h ------', this.orientationService.horizontal);
    //   console.log('------ v ------', this.orientationService.vertical);
    // });

    this.keyEventSubscribe('Shift+Y', () => {
      if (this.mainFrame) {
        this.copiedAnimation = cloneDeep(this.mainFrame.frameObject);
        this.notify('Animation has been copied!');
      }
    });

    // this.keyEventSubscribe('Shift+M', () => {
    //   if (this.copiedAnimation) {
    //     // this.saveAnimation(this.copiedAnimation);
    //     this.notify('Animation has been copied!');
    //   }
    // });

    this.keyEventSubscribe('Alt+ArrowUp', () => {
      this.consumeKeyEvent('ArrowUp');
      this.previewShape?.translateCanvas(0, 100 / this.canvasScale);
    });
    this.keyEventSubscribe('Alt+ArrowDown', () => {
      this.consumeKeyEvent('ArrowDown');
      this.previewShape?.translateCanvas(0, -100 / this.canvasScale);
    });
    this.keyEventSubscribe('Alt+ArrowLeft', () => {
      this.consumeKeyEvent('ArrowLeft');
      this.previewShape?.translateCanvas(100 / this.canvasScale, 0);
    });
    this.keyEventSubscribe('Alt+ArrowRight', () => {
      this.consumeKeyEvent('ArrowRight');
      this.previewShape?.translateCanvas(-100 / this.canvasScale, 0);
    });

    this.keyEventSubscribe('Space+ArrowLeft', () => {
      this.previewShape.shiftStateToLeft();
    });
    this.keyEventSubscribe('Space+ArrowRight', () => {
      this.previewShape.shiftStateToRight();
    });

    this.keyEventSubscribe('Shift+Z', () => this.undo());
    this.keyEventSubscribe('Shift+z', () => this.undo());
    this.keyEventSubscribe(
      'Shift+s',
      () => {
        this.patchFiles();
        this.consumeKeyEvent('s');
      },
      -10,
    );

    this.keyDownEventSubscribe('a', () => {
      if (this.shapeAddMode == 'path') {
        this.pathShapeExtendMode = 'line';
        this.consumeKeyEvent('a');
        return;
      }
    });

    this.keyDownEventSubscribe('s', () => {
      if (this.shapeAddMode == 'path') {
        this.pathShapeExtendMode = 'curve';
        this.consumeKeyEvent('s');
        return;
      }
    });

    this.keyDownEventSubscribe('d', () => {
      if (this.shapeAddMode == 'path') {
        this.pathShapeExtendMode = 'anchor-curve';
        this.consumeKeyEvent('d');
        return;
      }
    });

    this.keyEventSubscribe('Shift+a', async () => {
      this.shapes?.map(ps => ps.select());
      this.consumeKeyEvent('a');
    });

    this.keyEventSubscribe('z', () => this.flipZoomMode());
    this.keyEventSubscribe('m', () => this.flipPlayTillNextStage());

    this.keyEventSubscribe('e', () => {});

    this.keyEventSubscribe('y+m', () => {
      if (!this.previewShape) {
        return;
      }
    });

    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        event.preventDefault();
      }
      this.keyDown(event.code, event.key);
    });

    document.addEventListener('keyup', (event: KeyboardEvent) => {
      event.preventDefault();
      this.keyUp(event.code);
    });
  }

  enableCanvasCursorEvents() {
    this.app.stage.eventMode = 'dynamic';
  }

  disableCanvasCursorEvents() {
    this.app.stage.eventMode = 'none';
  }

  undo() {}
  redo() {}
  resetCanvasPosition() {
    this.previewShape.resetPosition();
  }
  flipPlayTillNextStage() {
    return;
    if (this.playOnlyTillNextStage) {
      this.playOnlyTillNextStage = false;

      // we need remove all so that after that we can add all shapes in the right order
      this.previewShape.shapesByIndex.map(shape =>
        shape.removeContainersFromParent(),
      );
      console.log('current-state', this.currentState);
      this.previewShape.shapesByIndex.map(shape =>
        shape.showHideByState(this.currentState),
      );
      this.previewShape.shapesByIndex.map(shape =>
        shape.addContainersToParent(),
      );
    } else {
      this.playOnlyTillNextStage = true;
      this.previewShape.shapesByIndex.map(shape =>
        shape.addRemoveByState(this.currentState),
      );
    }
  }

  // -- // -- // -- // -- //
  canvasWidth: number;
  canvasHeight: number;

  /***************************************************************************************/
  /**********************************     UTIL     ***************************************/
  /***************************************************************************************/

  private keyEvents: Record<string, Record<number, Subject<void>>> = {};
  private longKeyEvents: Record<string, Record<number, Subject<void>>> = {};
  private keyUpEvents: Record<string, Record<number, Subject<void>>> = {};
  private keyDownEvents: Record<string, Record<number, Subject<void>>> = {};
  private keyEventConsumed: Record<string, boolean> = {};
  private _keyEventConsumed = false;

  get sceneGap() {
    return (1 / 12) * (this.isPortrait ? this.portraitScreenX : _screenY);
  }

  get sceneWithGap() {
    if (this.isPortrait) {
      return this.portraitScreenX + this.sceneGap;
    } else {
      return _screenY + this.sceneGap;
    }
  }

  keyEventSubscribe(
    key: string,
    handler: (consume?: () => void) => void,
    prio = 0,
  ): Subscription {
    this.keyEvents[key] ||= {};
    this.keyEvents[key][prio] ||= new Subject();
    return this.keyEvents[key][prio].subscribe(() => {
      if (!this.keyEventConsumed[key] && !this._keyEventConsumed) {
        handler(() => this.consumeKeyEvent(key));
      }
    });
  }

  longKeyEventSubscribe(
    key: string,
    handler: (consume?: () => void) => void,
    prio = 0,
  ): Subscription {
    return;
    this.longKeyEvents[key] ||= {};
    this.longKeyEvents[key][prio] ||= new Subject();
    return this.longKeyEvents[key][prio].subscribe(() => {
      if (!this.keyEventConsumed[key] && !this._keyEventConsumed) {
        handler(() => this.consumeKeyEvent(key));
      }
    });
  }

  keyDownEventSubscribe(
    key: string,
    handler: (consume?: () => void) => void,
    prio = 0,
  ): Subscription {
    return;
    this.keyDownEvents[key] ||= {};
    this.keyDownEvents[key][prio] ||= new Subject();
    return this.keyDownEvents[key][prio].subscribe(() => {
      // TODO - keydownevents consumed
      if (!this.keyEventConsumed[key] && !this._keyEventConsumed) {
        handler(() => this.consumeKeyEvent(key));
      }
    });
  }

  keyDownHandler: (key: string) => void;
  registerKeyDownHandler(handler: (key: string) => void) {
    // console.log('registerKeyDownHandler', handler);
    this.keyDownHandler = handler;
  }

  deregisterKeyDownHandler() {
    this.keyDownHandler = null;
  }

  keyUp(key: string) {
    // -- // -- //

    key = this.mapKey(key);

    const diff = performance.now() - this.pressedKeys[key];

    delete this.pressedKeys[key];
    delete this.pressedKeys[key.toLowerCase()];

    // console.log('key-up', key);
    if (this.keyDownHandler) {
      return;
    }

    // if (!combos?.length) {
    // console.log('combos.length', combos.length);

    // if (combos?.length) {
    //   return;
    // }

    // TODO - move here key base keyEventConsumend check
    if (this._keyEventConsumed) {
      return;
    }

    if (this.keyEventConsumed[key]) {
      console.log('key-event-consumed', key);
      delete this.keyEventConsumed[key];
      return;
    }
    // -- // -- // -- //
    if (diff > 800 && this.longKeyEvents[key]) {
      Object.keys(this.longKeyEvents[key] || {})
        .sort((k1, k2) => +k1 - +k2)
        .map(prio => {
          this.longKeyEvents[key][prio].next();
        });
    } // -- // -- //

    this.emitKeyEvent(key);
  }

  mapKey(key: string) {
    if (key.startsWith('Shift')) {
      return 'Shift';
    }
    if (key.startsWith('Alt')) {
      return 'Alt';
    }

    if (key.startsWith('Meta')) {
      return 'Meta';
    }

    if (key.startsWith('Key')) {
      return key.slice(3).toLowerCase();
    }

    if (key.startsWith('Arrow')) {
      return key;
    }

    if (key.endsWith('Left')) {
      return key.slice(0, key.length - 4);
    }
    if (key.endsWith('Right')) {
      return key.slice(0, key.length - 5);
    }

    if (key.startsWith('Digit')) {
      return key.slice(5);
    }

    return `${key}`;
  }

  keyDown(code: string, key?: string) {
    // console.log('keyDown', { code, key, pressedKeys: this.pressedKeys });
    // -- //
    if (this.pressedKeys[key]) {
      return;
    }

    // console.log('KeyDown II.', code);
    if (key == 'Meta') {
      // console.log('keyDown > Meta'); //
    }

    // console.log({ code, key });
    // -- // -- //
    this.pressedKeys[code] = performance.now();
    this.pressedKeys[key] = this.pressedKeys[code];

    code = this.mapKey(code);
    if (this.keyDownHandler) {
      // console.log('KeyDown III.', code);
      return this.keyDownHandler(key || code);
    }
    const combos = Object.keys(this.pressedKeys).filter(
      pressedKey => !!this.keyEvents[`${pressedKey}+${code}`],
    );

    combos.map(combo => {
      this.emitKeyEvent(`${combo}+${code}`);
      this.consumeKeyEvent(combo);
      this.consumeKeyEvent(code);
    });

    this.emitKeyDownEvent(code);
  }

  emitKeyDownEvent(key: string) {
    Object.keys(this.keyDownEvents[key] || {})
      .sort((k1, k2) => +k1 - +k2)
      .map(prio => {
        // console.log('emitKeyEvent', key, prio); //
        this.keyDownEvents[key][prio].next();
      });
  }

  preKeyEventConsumed: Record<string, boolean> = {};

  addSubtitle(): string {
    // -- //
    return '';
  }

  emitKeyEvent(key: string) {
    if (this.preKeyEventConsumed[key]) {
      delete this.preKeyEventConsumed[key];
      return;
    }

    // this._keyEventConsumed = false;
    // this.keyEventConsumed[key] = false;
    Object.keys(this.keyEvents[key] || {})
      .sort((k1, k2) => +k1 - +k2)
      .map(prio => {
        // console.log('emitKeyEvent', key, prio);
        this.keyEvents[key][prio].next();
      });
  }

  emitKeyUpEvent(key: string) {
    Object.keys(this.keyUpEvents[key] || {})
      .sort((k1, k2) => +k1 - +k2)
      .map(prio => {
        if (!this.keyEventConsumed[key]) {
          this.keyUpEvents[key][prio].next();
        }
      });
  }

  preConsumeKeyEvent(key: string) {
    this.preKeyEventConsumed[key] = true;
  }

  consumeKeyEvent(key?: string, code?: string) {
    if (key.includes('+')) {
      return key.split('+').map(k => this.consumeKeyEvent(k));
    }

    if (key?.length == 1) {
      key = key?.toLowerCase();
    }
    // if (!key) {
    //   this._keyEventConsumed = true;
    // }
    this.keyEventConsumed[key] = true;
    this.keyEventConsumed[code] = true;
    setTimeout(() => {
      this.keyEventConsumed[key] = false;
      this.keyEventConsumed[code] = false;
    }, 100);
  }

  generalEventSubscribe(key: string, handler: (e: any) => void) {
    this.generalEvents[key] ||= new Subject();
    return this.generalEvents[key].subscribe(e => handler(e));
  }

  generalEventEmit(key: string, event?: any) {
    if (!this.generalEvents[key]) {
      return;
      // throw new Error(`Invalid key (${key}) for general event emit!`);
    }
    this.generalEvents[key].next(event == undefined ? Math.random() : event);
  }

  generalSelectorConfig: GeneralSelectorConfig;
  generalSelectorConfigEnabled = false;
  generalSelectorCallback: (result: string, allResults?: string[]) => void;

  generalSelectorFinished(result: string, allResults: string[]) {
    this.generalSelectorCallback(result, allResults);
    this.generalSelectorCallback = () => null;
    this.generalSelectorConfigEnabled = false;
  }

  openGeneralSelector(
    options: GeneralSelectorConfig,
    callBack: (result: string, allResults: string[]) => void,
  ) {
    this.generalSelectorConfig = options;
    // TODO - The callback should be called from the component
    this.generalSelectorCallback = callBack;
  }

  consumeClick() {
    this.clickAbsorbed = true;
    // this.disableClick();
  }

  clearKeys() {
    this.pressedKeys = {};
  }

  isPressed(key: string | string[]) {
    return Array.isArray(key)
      ? !!key.find(k => this.pressedKeys[k])
      : !!this.pressedKeys[key];
  }

  absoluteSceneGap: number;
  absoluteCanvasX: number;
  absoluteCanvasY: number;
  absoluteCanvasWidth: number;
  absoluteCanvasHeight: number;

  canvasDims: [number, number];
  __canvasHeight: number;

  canvasTop: number;
  get settingsTop() {
    const [, h] = this.canvasDims;
    return;
  }

  _resizeCanvas(w: number, h: number) {
    this.canvasDims = [w, h];
    let scale: number;

    let targetWidth: number, targetHeight: number;

    if (this.isPortrait) {
      targetWidth = (12 / 8) * this.portraitScreenX;
      targetHeight = this.portraitScreenY;
    } else {
      targetWidth = _screenX;
      targetHeight = (12 / 8) * _screenY;
    }

    /* console.log('targetWidth', targetWidth, 'targetHeight', targetHeight);
    console.log('devicePixelRatio', window.devicePixelRatio);
    console.log(
      'actual canvas size will be',
      targetWidth * window.devicePixelRatio,
      (targetHeight - 4) * window.devicePixelRatio,
    ); */

    const targetRatio = w / h;
    const ratio = targetWidth / targetHeight;

    if (targetRatio < ratio) {
      // this is more landscape direction - y should be scaled.
      scale = w / targetWidth;
    } else {
      scale = this.isPortrait ? w / this.portraitScreenX : w / _screenX;
      // -- // -- //
    }
    // console.log('scale', scale); //
    this.canvasContainer.scale.x = scale;
    this.canvasContainer.scale.y = scale;
    this.canvasBackgroundContainer.scale.x = scale;
    this.canvasBackgroundContainer.scale.y = scale;

    this.canvasCircleContainer.scale.x = scale;
    this.canvasCircleContainer.scale.y = scale;
    this.fitScale = scale;
    this.canvasScale = scale;
    this.generalEventEmit('fit-canvas-updated', scale);

    this.absoluteSceneGap = this.sceneGap * scale;
    this.__canvasHeight = targetHeight * scale;

    this.canvasTop = (h - this.__canvasHeight) / 2 - 26;

    if (this.isPortrait) {
      this.absoluteCanvasX = (this.portraitScreenX / 4) * this.fitScale;
      this.absoluteCanvasY = 0;
      this.absoluteCanvasWidth = this.portraitScreenX * scale;
      this.absoluteCanvasHeight = this.portraitScreenY * scale;

      this.app.renderer.resize(targetWidth * scale - 4, targetHeight * scale);
      this.rootContainer.position.x =
        (this.portraitScreenX / 4) * this.fitScale;
    } else {
      this.absoluteCanvasX = 0;
      this.absoluteCanvasY = (_screenY / 4) * this.fitScale;

      this.absoluteCanvasWidth = _screenX * scale;
      this.absoluteCanvasHeight = _screenY * scale;

      this.app.renderer.resize(targetWidth * scale, targetHeight * scale - 4);
      this.rootContainer.position.y = (_screenY * scale) / 4;
    }
  }

  resizeCanvas(w: number, h: number) {
    // console.log('----- w -------', w, '-------- h -------', h); //
    const ratio = _screenX / _screenY;
    if (h <= w) {
      this.canvasWidth = w;
      this.canvasHeight = w / ratio;
    } else {
      this.canvasHeight = h / ratio;
      this.canvasWidth = w;
    }
    // -- // -- //
    console.log('canvasWidth', this.canvasWidth);
    console.log('canvasHeight', this.canvasHeight);
    this.app.renderer.resize(
      this.canvasWidth - 4,
      (12 / 8) * this.canvasHeight,
    );

    this.rootContainer.position.y = this.canvasHeight / 4;
    // -- // -- // -- //
    this.fitCanvas();
  }

  logX(shape: GeneralShape, message: string) {
    if (this.logShapes.includes(shape.IRI)) {
      console.log(message);
    }
  }

  mouseMoveEvent(xa: number, ya: number) {
    // this.canvasX = xa; // - this.canvasOffset.x; // -- //
    // this.canvasY = ya; // - this.canvasOffset.y; // -- //
    // this.mouseMove.next(this.getAbsoluteCoords(xa, ya, true)); // .. // .. //
    this.mouseMove.next({ x: xa, y: ya });
  }

  /***************************************************************************************/
  /**********************************  TRANSFORM   ***************************************/
  /***************************************************************************************/

  transform(x: number, y: number, scaleIn?: boolean) {
    this.previewShape.transformAction({
      x,
      y,
      scale: scaleIn ? SCALE_IN : 1 / SCALE_IN,
    });

    this.showFitCanvas = true;
  }

  _scaleValue = 1;

  updateDimension(x: number, y: number, scaleIn: boolean) {
    // RIP - rip indeed
    if (this._scaleValue === 0 && this.canvasX === 0 && this.canvasY === 0) {
      this.canvasX = x;
      this.canvasY = y;
      return;
    }

    if (
      (this._scaleValue === 1 && !scaleIn) ||
      (this._scaleValue === -1 && scaleIn)
    ) {
      const [xd, yd] = [x - this.canvasX, y - this.canvasY];
      const angle =
        xd !== 0 || yd !== 0 ? Math.atan(Math.abs(yd) / Math.abs(xd)) : 0;

      const d = Math.sqrt(Math.pow(xd, 2) + Math.pow(yd, 2));
      const dNew = d * (scaleIn ? SCALE : SCALE / SCALE_IN);

      const [dx, dy] = [
        dNew * Math.cos(angle) * Math.sign(xd),
        dNew * Math.sin(angle) * Math.sign(yd),
      ];

      if (!scaleIn) {
        this.canvasX = dx;
        this.canvasY = dy;
      } else {
        this.canvasX = -dx;
        this.canvasY = -dy;
      }
      return;
    }

    if (this._scaleValue === 0 && (this.canvasX !== 0 || this.canvasY !== 0)) {
      const { x: xa, y: ya } = this.getAbsoluteCoords(x, y, true);
      const ratio = scaleIn ? 1 / SCALE : -1 / SCALE - 1;
      this.canvasX = xa - this.canvasX * ratio;
      this.canvasY = ya - this.canvasY * ratio;
      return;
    }

    const ratio = scaleIn
      ? lookup_scale_in[this._scaleValue]
      : lookup_scale_out[this._scaleValue];
    this.canvasX += (x - this.canvasX) * ratio;
    this.canvasY += (y - this.canvasY) * ratio;
  }

  getAbsoluteCoords(x: number, y: number, noOffset = false) {
    x /= this.canvasScale;
    y /= this.canvasScale;
    return {
      x: -this.canvasX / this.canvasScale + x,
      y: -this.canvasY / this.canvasScale + y,
    };
  }

  _getAbsoluteCoords(x: number, y: number, noOffset = false) {
    const [, h] = this.fitTranslate;
    return {
      x: x * this.canvasScale,
      y: y * this.canvasScale + h,
    };
  }

  getRelativeCoords(x: number, y: number) {
    x *= this.canvasScale;
    y *= this.canvasScale;

    return [-this.canvasX + x, -this.canvasY + y];
  }

  get selectedImportedShapes() {
    return this.shapes.filter(
      shape =>
        shape instanceof ImportedShape && shape.selected && !shape.hidden,
    ) as ImportedShape[];
  }

  get canvasX() {
    return this.previewShape?.translateX || 0;
  }

  set canvasX(val: number) {
    this.previewShape.translateX = val;
  }

  get canvasY() {
    return this.previewShape?.translateY || 0;
  }

  set canvasY(val: number) {
    this.previewShape.translateY = val;
  }

  getAbsCoordsInverse(x: number, y: number) {
    if (this.canvasScale === 1) {
      return {
        x: x + this.canvasX,
        y: y + this.canvasY,
      };
    } else {
      const origin = [
        (this.canvasX * (this.canvasScale - 1)) / this.canvasScale,
        (this.canvasY * (this.canvasScale - 1)) / this.canvasScale,
      ];

      return {
        x: (x - origin[0]) * this.canvasScale,
        y: (y - origin[1]) * this.canvasScale,
      };
    }
  }

  /***************************************************************************************/
  /**********************************    PROJECT   ***************************************/
  /***************************************************************************************/

  currentProject: ResourceData;
  colorOptions: any;

  setCurrentProject(project: ResourceData) {
    this.currentProject = project;
    // console.log('currentProject', this.currentProject.literals.descriptor);

    this.generalEventEmit('color-options-loaded');
  }

  async setColorOptions() {
    this.colorOptions = [];
    if (this.previewShape) {
      this.colorOptions.push(...this.previewShape.colorInputs);
    }
    this.colorOptions.push(
      ...Object.entries(
        this.currentProject?.literals.descriptor?.colorPalette || {},
      ).map(([key, value]) => ({
        key,
        value,
      })),
    );
  }

  /***************************************************************************************/
  /**********************************     FILE     ***************************************/
  /***************************************************************************************/

  cutFileItem: ResourceData<{}, {}>;

  cutFile(data: ResourceData) {
    this.cutFileItem = data;
  }

  async pasteFile(folderIRI: string) {}

  /***************************************************************************************/
  /**********************************     SHAPE    ***************************************/
  /***************************************************************************************/

  adjusts: Record<string, { dx: number; dy: number }> = {};
  _panelStable = true;

  set panelStable(val: boolean) {
    this._panelStable = val;
    // console.log('panelStable set to', val);
    this.store.dispatch(setPanelStable({ value: val }));
  }

  get panelStable() {
    return this._panelStable;
  }

  addAdjust(id: string, dx: number, dy: number) {
    this.adjusts[id] ||= { dx: 0, dy: 0 };
    this.adjusts[id].dx = dx;
    this.adjusts[id].dy = dy;
  }

  patchAdjust(id: string, key: 'dx' | 'dy', value: number) {
    if (!this.adjusts[id]) {
      return;
    }
    this.adjusts[id][key] = value;
  }

  removeAdjust(id: string) {
    delete this.adjusts[id];
  }

  postAdjusts() {
    Object.entries(this.adjusts).map(([key, { dx, dy }]) => {
      // console.log('applyAdjustMent', dx, dy);
      this.pathSections[key]?.applyAdjustment(dx, dy);
    });
    this.adjusts = {};
    // TODO - check if it necessary
    // this.shapes
    //  .filter((ps: PathShape) => ps.hasBeenChanged)
    //  .map(ps => ps.refresh());
  }

  get _selectedShapes() {
    return (
      this.previewShape?.shapes.filter(
        shape => shape.selected && shape.getType() !== 'root-shape',
      ) || []
    );
  }

  get selectedShapes(): GeneralShape[] {
    return (
      this.previewShape?.shapes.reduce((acc, shape) => {
        acc.push(...shape.selectedShapes());
        return acc;
        // }, (this.previewShape.selected ? [this.previewShape] : []) as GeneralShape[]) ||
      }, [] as GeneralShape[]) || []
    );
  }

  goToRecord() {}

  _shapesToDrag: GeneralShape[];
  _shapesToDragLength: number;

  get isAltPressed() {
    return this.isPressed('Alt');
  }

  get isSpacePressed() {
    return this.isPressed('Space');
  }

  get isControlPressed() {
    return this.isPressed('Control');
  }

  dragDiff: Coords;

  dragging = false;

  selectorDimensions = { x: 0, y: 0, width: 0, height: 0 };

  copyDescriptor() {
    navigator.clipboard.writeText(this.previewShape?.descriptorObject);
    this.notify('Descriptor has been copied!');
  }

  descriptorImport = false;

  importedDescripor: any;

  importDescriptor() {
    this.descriptorImport = true;
  }

  addToCanvas(shape: GeneralShape) {
    this.app.stage.addChild(shape.container);
  }

  addToPreview(shape: GeneralShape) {
    this.previewApp.stage.addChild(shape.container);
  }

  deselectAll(params: ShapeSelectParams = {}) {
    this.shapes.map(shape => shape.deselect(params));
  }

  /***************************************************************************************/
  /**********************************   ANIMATION  ***************************************/
  /***************************************************************************************/

  functionIds: Record<string, boolean> = {};
  animationIsBeingPlayed = false;
  batchPerSecond = 60;

  noAnimationMode = false;
  currentFunctionName = 'main';

  get mainFrame() {
    return this.previewShape?.animationFrame;
  }

  set mainFrame(frame: RootAnimationFrame) {
    this.previewShape.animationFrame = frame;
  }

  addFirstFrame() {
    // -- //
    console.log('-------yooooo xyz /----------');

    this.currentAnimation = { id: Math.random().toString(), duration: 1 };
    this.mainFrame = new RootAnimationFrame(
      this.previewShape,
      this.currentAnimation,
    );
    console.log('---------- add-first-frame ----------');
    this.store.dispatch(
      setMainAnimationFrame({
        frame: cloneDeep(this.currentAnimation),
      }),
    );

    return this.mainFrame;
  }

  get animationFrame() {
    return this.previewShape?.descriptor?.animationFrame;
  }

  currentAnimation: AnimationFrame;
  currentAnimationFrame: AnimationFrameObject;

  async waitForsoundFilesAndPlay() {
    const sounds = {};
    const framesById = this.mainFrame.framesById;
    Object.entries(framesById).map(([id, frame]) => {
      if ((frame as SoundAnimationFrame).soundFileUrl) {
        sounds[id] = true;
      }
    });

    console.log({ sounds });

    // await new Promise(res => {
    //   const sub = this.generalEventSubscribe('sound-loaded', (id) => {
    //     delete sounds[id];
    //     if (Object.keys(sounds).length == 0) {
    //       sub.unsubscribe();
    //       res(null);
    //     }
    //   })
    // })
  }
  animationBlocked = false;
  async sectionAnimations(id: string, duration: number, inverse = false) {
    const shapesToAnimate = this.currentResources.filter(
      shape => !!shape.hasAnimation?.(id) && !shape.removed,
    ) as GeneralShape[];

    if (!shapesToAnimate.length) {
      return this.waitMs(duration * 1_000);
    }

    const numberOfBatches = Math.floor(duration * this.batchPerSecond);
    shapesToAnimate.map(shape =>
      shape.startAnimation(id, numberOfBatches || 1, inverse, duration),
    );

    const timeOfOneBatchInMs = 1000 / this.batchPerSecond;

    let increment = 0;
    let executionTime = 0;
    let referenceTime = 0;
    for (let i = 0; i < numberOfBatches; i++) {
      const start = performance.now();
      if (executionTime < referenceTime) {
        await this.waitMs(referenceTime - executionTime);
        increment = 1;
      } else {
        // speed up
        increment++;
        increment = Math.min(4, increment);
      }

      shapesToAnimate
        .sort((s1, s2) => s1.index - s2.index)
        .map((shape: GeneralShape) => {
          shape.incrementAnimation(increment, id);
        });

      executionTime += performance.now() - start;
      referenceTime += increment * timeOfOneBatchInMs;
      i += increment - 1;
    }
    shapesToAnimate.map(s => s.endAnimation(id));
  }

  zoomMode = false;

  flipZoomMode() {
    this.zoomMode = !this.zoomMode;
    console.log('flip-zoom-mode', this.zoomMode);
  }

  defineInputs() {
    this.previewShape?.editInputs();
  }

  openFunctionEditor() {
    // this.dialog.open(CodeEditorComponent, {
    //   data: { content: 'elemnt.stroke({ a: "1"}, 10)' },
    // });
    // console.log('open-function-editor');
  }

  auxMode = false;

  flipAuxMode() {
    this.auxMode = !this.auxMode;
  }

  shapeRecordMode = false;
  selectedShapesObject: Record<string, boolean> = {};

  startRecordMode(IRI: string, selectedIRIs: string[]) {
    // TODO - migrate
    // this.shapeRecordMode = true;
    // this.blinkIRI = IRI;
    // this.selectedShapes.map(shape => shape.deselect());
    // selectedIRIs.map(iri => {
    //   const shape = this.getResource(iri);
    //   if (!shape) {
    //     return;
    //   }
    //   shape.select();
    //   this.selectedShapesObject[iri] = true;
    // });
  }

  stopRecordMode() {
    this.shapeRecordMode = false;
    this.blinkIRI = null;
    this.selectedShapesObject = {};
    this.selectedShapes.map(shape => shape.deselect());
  }

  selectedShapesStore: GeneralShape[] = [];

  select(shape?: GeneralShape) {
    // if (this.shapeRecordMode) {
    //   this.emitSelectedShapes();
    // }
    // if (shape) {
    //   this.selectedShapesStore.push(shape);
    // }
    // if (this.shapeRecordMode) {
    //   return;
    // }
    // if (this.isPressed('Shift') && this.selectedShapesStore.length > 1) {
    //   this.shapeService.initGroupRC();
    // } else {
    //   this.shapeService.hideGroupRC();
    // }
  }

  draggingPathSection: PathSection | undefined;
  draggedSVGElement: SVG;
  hoveredPointController: PointController;

  disableClick(time = 10) {
    this.clickDisabled = true;
    setTimeout(() => (this.clickDisabled = false), time);
  }

  async waitMs(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /****************** GETTERS ***********************/

  get now() {
    return performance.now();
  }

  get timeSinceStart() {
    return this.now - this.started;
  }

  get selectedIRIs() {
    return Object.keys(this.selectedShapes);
  }

  /****************** COMPONENT CALL ***********************/

  callComponent(
    target: ComponentType | ComponentType[],
    type: string,
    message?: any,
  ) {
    this.componentCall.emit({ target, type, message });
  }

  addLabel() {
    const labelName = prompt('Name of the label:');
    if (Object.keys(this.shapeAlias).includes(labelName)) {
      alert('The labelName already exists. Try to use prefixes!');
      return;
    }
    this.shapeAlias[labelName] = Object.keys(this.selectedShapes)[0];
  }

  /****************** IMAGE ***********************/

  get isImageShape() {
    return this.previewShape?.getType() == 'image-shape';
  }

  /****************** RESOURCE ***********************/

  setPicture(picture: ImageDescriptor) {
    // this.images[picture.label] = picture;
  }

  /*********************** STATE SETTING ************************/

  async command(key: number, x?: number, y?: number) {
    switch (key) {
      case 1:
        console.log('Up');
        this.translate(0, -100);
        break;
      case 2:
        console.log('Down');
        this.translate(0, 100);
        break;
      case 3:
        console.log('Left');
        this.translate(-100, 0);
        break;
      case 4:
        console.log('Right');
        this.translate(100, 0);
        break;

      default:
        break;
    }
  }

  /******************************* SelectorRectangle *************************/

  notification: string;

  notify(notification: string, time = 2_000) {
    this.notification = notification;
    setTimeout(() => (this.notification = null), time);
  }

  /********************************** Other ***********************************/

  resetImage() {
    // this.resourceStore = {};
    this.canvasScale = 1; // -- //

    this.generalEventEmit('clear-resource-store');
    this.currentAnimation = null;

    this.zoomMode = false;
    this.auxMode = false;

    this.animationIsBeingPlayed = false;
    this.animationBlocked = false;

    this.stopRecordMode();

    // this.previewShape?.removeAll(); // -- // -- //
  }

  /*********************** TRANSFORM ************************/

  yOffset = _screenY / 8;
  // -- // -- //

  debounce = 0;
  lastDx: number;
  lastDy: number;

  blocked = false;

  leaveTimeout: NodeJS.Timeout;

  currentX = 0;
  currentY = 0;

  minCanvasY = 0;
  minCanvasX = 0;
  get isLastScene() {
    if (this.isPortrait) {
      return this.currentX <= this.minCanvasX;
    } else {
      return this.currentY <= this.minCanvasY;
    }
  }

  get isFirstScene() {
    return this.currentY == 0;
  }

  translateCanvas(dx: number, dy: number) {
    if (this.blocked) {
      return;
    }
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
    }

    // this.showFitCanvas = true;

    if (this.isPortrait) {
      // this.currentX += dx;
      const nextPosition = this.currentX + dy;
      if (nextPosition > 0) {
        this.currentX = 0;
        this.panelStable = true;
        this.store.dispatch(setCurrentStudioSceneIndex({ value: 0 }));
        return;
      }

      // console.log('nextPosition', nextPosition, 'minCanvasY', this.minCanvasY);
      if (nextPosition < this.minCanvasX) {
        this.currentX = this.minCanvasX;
        this.panelStable = true;
        this.store.dispatch(setCurrentStudioSceneIndex({ value: undefined }));
        return;
      }

      this.panelStable = false;
      this.currentX = nextPosition;
      this.generalEventEmit('currentX', this.currentX);
      // console.log('currentX < set by nextPosition', this.currentX);
      this.lastDx = dy;
      // if (!this.lastDx) {
      //   this.lastDx = dy;
      // } else {
      //   if (this.lastDx * dy < 0) {
      //     this.lastDx = dy;
      //     this.debounce = 0;
      //     return;
      //   }

      //   this.debounce++;
      // }
      // -- // -- //
    } else {
      // this.currentY += dy;
      const nextPosition = this.currentY + dy;

      // console.log('nextPosition', nextPosition);

      if (nextPosition > 0) {
        this.currentY = 0;
        this.panelStable = true;
        this.generalEventEmit('currentY', this.currentY);
        this.store.dispatch(setCurrentStudioSceneIndex({ value: 0 }));
        return;
      }

      // console.log('nextPosition', nextPosition, 'minCanvasY', this.minCanvasY);
      if (nextPosition < this.minCanvasY) {
        // console.log('nextPosition < minCanvasY', this.minCanvasY);
        this.currentY = this.minCanvasY;
        this.panelStable = true;
        // this is for the last //
        this.generalEventEmit('currentY', this.currentY);
        this.store.dispatch(setCurrentStudioSceneIndex({ value: undefined }));
        return;
      }

      this.panelStable = false;
      this.currentY = nextPosition;
      this.generalEventEmit('currentY', this.currentY);
      this.lastDy = dy;
      // if (!this.lastDy) {
      //   this.lastDy = dy;
      // } else {
      //   // direction change
      //   if (this.lastDy * dy < 0) {
      //     this.lastDy = dy;
      //     this.debounce = 0;
      //     return;
      //   }

      //   this.debounce++;
      // }
    }

    this.leaveTimeout = setTimeout(() => {
      this.moveToScene();
    }, 200);
  }

  moveToScene() {
    if (this.blocked) {
      return;
    }

    this.store.dispatch(deselectAllShapes());
    if (this.isPortrait) {
      // -- // -- //
      const position = this.currentX;
      const period = this.sceneWithGap * this.fitScale;
      const place = Math.floor(-position / period);
      let target: number;
      if (this.lastDx < 0) {
        target = -(place + 1) * period;
        this.store.dispatch(setCurrentStudioSceneIndex({ value: place + 1 }));
      } else {
        target = -place * period;
        this.store.dispatch(setCurrentStudioSceneIndex({ value: place }));
      }
      const object = { x: this.currentX };
      gsap.to(object, {
        x: target,
        duration: 0.2,
        ease: 'power1.inOut',
        onUpdate: () => {
          this.currentX = object.x;
          this.generalEventEmit('currentX', this.currentX);
        },
        onComplete: () => {
          this.panelStable = true;
        },
      });
    } else {
      const position = this.currentY;
      const period = this.sceneWithGap * this.fitScale;
      const place = Math.floor(-position / period);

      let target: number;

      if (this.lastDy < 0) {
        target = -(place + 1) * period;
        this.store.dispatch(setCurrentStudioSceneIndex({ value: place + 1 }));
      } else {
        target = -place * period;
        this.store.dispatch(setCurrentStudioSceneIndex({ value: place }));
      }

      const object = { y: this.currentY };
      gsap.to(object, {
        y: target,
        duration: 0.2,
        ease: 'power1.inOut',
        onUpdate: () => {
          this.currentY = object.y;
          this.generalEventEmit('currentY', this.currentY);
        },
        onComplete: () => {
          // console.log('moveToScene > onComplete');
          this.panelStable = true;
        },
      });
    }

    this.blocked = true;
    setTimeout(() => (this.blocked = false), 500);
    this.debounce = 0;
  }

  moveDown(updateCurrentY = true) {
    this.moveCurrentYTo(
      this.currentY - this.sceneWithGap * this.fitScale,
      updateCurrentY,
    );
  }

  moveUp(updateCurrentY = true) {
    this.moveCurrentYTo(
      this.currentY + this.sceneWithGap * this.fitScale,
      updateCurrentY,
    );
  }

  moveCurrentYTo(target: number, updateCurrentY = true) {
    const object = { y: this.currentY };
    gsap.to(object, {
      y: target,
      duration: 0.5,
      ease: 'power1.inOut',
      onUpdate: () => {
        if (updateCurrentY) {
          this.currentY = object.y;
        }
        this.generalEventEmit('currentY', object.y);
      },
      onComplete: () => {
        this.panelStable = true;
      },
    });
  }

  xscale(x: number, y: number, delta: number) {
    this.transform(x, y, delta > 0);
    this.generalEventEmit('canvasScale', {});
  }

  mouseDownFromElement = false;

  translate(x: number, y: number) {}

  // -- //
  // async zoomAnimate() {
  //   // --> //
  //   const dScale = 0.728 / 100;
  //   const dx = -165.984 / 100;
  //   const dy = -641.368 / 100;
  //   for (let i = 0; i < 100; i++) {
  //     this.previewShape.currentMatrix.translate(dx, dy);
  //     this.previewShape.currentMatrix.scale(1 + dScale);
  //     this.previewShape.outerElementGroup.attr({
  //       transform: this.previewShape.currentMatrix,
  //     });
  //     // this.previewShape.zoom({
  //     //   x: 100,
  //     //   y: 100,
  //     //   scale: 1 + i * 0.01,
  //     // });
  //     await this.waitMs(20);
  //   }
  // }

  showBoundingRectangle() {
    // -- //
    let xMin = Infinity,
      yMin = Infinity,
      xMax = -Infinity,
      yMax = -Infinity;
    for (const shape of this.previewShape.shapes) {
      if (shape.auxMode || shape.maskedBy) {
        continue;
      }

      if (shape.IRI == this.previewShape.IRI) {
        continue;
      }

      const { x, y, width, height } = shape.container.getBounds();

      if (height == 0 && height == 0) {
        continue;
      }

      if (x < xMin) xMin = x;
      if (y < yMin) yMin = y;
      if (xMax < x + width) xMax = x + width;
      if (yMax < y + height) yMax = y + height;
    }

    return;
    const rc = new RectangleController(
      this.previewShape,
      {
        offset: [xMin, yMin],
        width: xMax - xMin,
        height: yMax - yMin,
        startDrag: () => null,
        drag: params => null,
        endDrag: () => null,
        noDrag: true,
      },
      this.previewShape.auxCircleContainer,
      this.previewShape.auxCircleContainer,
    );
  }

  getSelectedBoundingRectangle() {
    // -- // -- //
    let xMin = Infinity,
      yMin = Infinity,
      xMax = -Infinity,
      yMax = -Infinity;
    for (const shape of this._shapesToDrag) {
      const { x, y, width, height } = shape.container.getBounds();

      if (x < xMin) xMin = x;
      if (y < yMin) yMin = y;
      if (xMax < x + width) xMax = x + width;
      if (yMax < y + height) yMax = y + height;
    }

    return { xMin, yMin, xMax, yMax };
  }

  // ************** base-shape-control ******************** //

  shapeAddMode:
    | 'rectangle'
    | 'circle'
    | 'glow'
    | 'path'
    | 'text'
    | 'comment'
    | 'image'
    | 'image-gen';

  pathShapeAddMode: 'line' | 'curve' | 'anchor-curve';
  // Maybe later can be used for debug purposes
  // refreshCircle() {
  //   if (!this.circle && !!this.snap) {
  //     this.circle = this.snap.circle(this.canvasX, this.canvasY, 4).attr({
  //       fill: 'white',
  //       stroke: 'black',
  //     });
  //   } else {
  //     this.circle.attr({ cx: this.canvasX, cy: this.canvasY });
  //   }
  // }

  uploadeFile: File;

  /******************************* SAVE / UNDO / REDO ******************************/

  get auxLineConfig() {
    return {
      stroke: '#ff0000',
      'stroke-width': 1,
      'stroke-opacity': 0.5,
    };
  }

  get undoDisabled() {
    return this.currentPatch === 0;
  }

  get redoDisabled() {
    return this.currentPatch >= this.patchCount;
  }

  tmpIRIs: string[] = [];

  async patchFiles() {
    this.store.dispatch(saveResourcesAction());
    // this.store.dispatch(saveStudioResources());
  }

  async saveThumbnail(url: string) {
    return;
    this.httpService.saveImageToS3(
      url,
      this.currentFileID + '_thumbnail.png',
      'image/png',
    );
  }

  tmpFunctionFrames: Record<string, AnimationFrameObject> = {};

  clone(object: any) {
    return JSON.parse(JSON.stringify(object));
  }

  resetStore() {
    this.generalEventEmit('shapes', []);
    this.updateStore();
  }

  updateStore() {
    this.generalEventEmit('shapes', this.shapes);
  }

  get shapes(): GeneralShape[] {
    return this.previewShape?.shapes || [];
  }

  get allShapes() {
    return this.previewShape?.shapes.reduce((prev, curr) => {
      prev.push(...curr.allShapes);
      return prev;
    }, [] as GeneralShape[]);
  }

  currentPatch = parseInt(INITIAL_PATCH_KEY);
  patchCount = 0;

  patchIncrement() {
    this.currentPatch++;
    this.patchCount++;
  }

  patch(key: string, value: any) {
    this.patchIncrement();
    this.selectedShapes.map(shape => shape.patch(key, value));
  }

  reInits: PathShape[] = [];

  /******************************** Animation *********************************/

  getTarget({ type, id }: { type: ConstraintEntity; id: string }) {
    switch (type) {
      case 'section':
      case 'point':
      case 'point:a1':
      case 'point:a2':
        return this.pathSections[id];
    }
  }

  indirectPatches: Record<string, Record<string, boolean>> = {};

  addIndirectPatch(IRI: string, key: string) {
    this.indirectPatches[IRI] ||= {};
    this.indirectPatches[IRI][key] = true;
  }

  indirectPatch() {
    Object.entries(this.indirectPatches).map(([IRI, value]) => {
      Object.keys(value).map(key => {
        if (this.resourceStore[IRI]) {
          this.resourceStore[IRI]?.patchByKey(key);
        } else {
          console.warn(`Patch target (${IRI}) doesn't exists.`);
        }
      });
    });
    this.indirectPatches = {};
  }

  refresh() {
    this.generalEventEmit('refresh');
  }

  clickAbsorbed = false;
  mouseDownAbsorbed = false;
  // It is true when a selector rectangle is dragged
  mouseDownFree = false;
  b1: number;
  b2: number;

  animationFrameCut: {
    frame: AnimationFrameObject;
    fcnName: string;
  };

  sidePanelDragState = false;

  currentResourceData: ResourceData;

  draggedResource: ResourceData;

  get activeFrame(): RootAnimationFrame {
    return this.mainFrame;
  }

  reloadPreviewShape() {
    this.generalEventEmit('route-update', {});

    if (!this.previewShape) {
      return;
    }
    this.previewShape.remove();
  }

  scaleOffset = 1;
  translateOffsetX = 0;
  translateOffsetY = 0;

  rootFixContainer: Container;
  rootContainer: Container;
  canvasContainer: Container = new Container();
  canvasBackgroundContainer: Container = new Container();

  canvasCircleContainer: Container = new Container();
  addSceneToCanvas(shape: RootShape, offset?: Coords) {
    this.canvasContainer.removeChildren();
    this.canvasContainer.addChild(shape.mainContainer);

    const [x, y] = offset || [0, 0];
    shape.rootContainer.position = { x, y };
  }

  async addRootShapeToCanvas(rootShape: RootShape) {
    this.canvasContainer.removeChildren();

    // this.canvasContainer.position.y = (1 / 8) * _screenY;
    this.currentRootShape = rootShape as FileRootShape;
    // -- // -- //
    if (!rootShape) {
      return;
    }

    // this.backgroundService.setById(
    //   (rootShape.descriptor as FileDescriptor).backgroundDefinitionId,
    // );
    // this.canvasContainer.addChild(this.backgroundService.container);
    this.canvasContainer.addChild(rootShape.rootContainer);

    this.previewShape = rootShape;

    let next = rootShape.next as FileRootShape;
    let i = 0;

    while (next) {
      this.canvasContainer.addChild(this.backgroundService.nextContainer);
      this.canvasContainer.addChild(next.rootContainer);
      next.rootContainer.position.y = ++i * this.sceneWithGap;
      this.backgroundService.initNext(next);
      next = next.next as FileRootShape;
    }

    // this.backgroundService.container.position.y = -(3 / 5) * screenY;
    // rootShape.rootContainer.position.y = -(3 / 5) * screenY;

    const config = {
      browser: {
        x: -165,
        y: 33,
        scale: 1.05,
      },
      main: {
        x: 76,
        y: 58,
        scale: 0.9,
      },
      chart: {
        x: -52,
        y: 12,
        scale: 1.2,
      },
      base: {
        x: 0,
        y: 0,
        scale: 1,
      },
    };

    await this.fitCanvas();
  }

  currentRootShape: FileRootShape;
  replaceRootShape(
    rootShape = this.previewShape.next as FileRootShape,
    transition?: SceneTransition,
  ) {
    // const delay = transition?.removeDelay || transition?.overlap || 0;

    const { duration, overlap } = transition || {};
    this.currentRootShape = rootShape as FileRootShape;
    this.previewShape = rootShape;

    // if (noShow) {
    rootShape.showElements();
    // }
    switch (transition?.from) {
      case 'left':
        rootShape.rootContainer.position.x = screenX;
        break;
      case 'right':
        rootShape.rootContainer.position.x = -screenX;
        break;
      case 'top':
        rootShape.rootContainer.position.y = screenY;
        break;
      case 'bottom':
        rootShape.rootContainer.position.y = -screenY;
        break;
    }

    this.canvasContainer.addChild(rootShape.rootContainer);
    const delay = (duration || 0) - (overlap || 0);
    setTimeout(() => {
      if (this.canvasContainer.children.length > 2) {
        this.canvasContainer.removeChildAt(1);
      }
    }, delay * 1_000);

    // this.canvasContainer.removeChildAt(1); //
  }
  thumbnailUpdated = false;
  animationThumbnails: Record<string, string> = {};
  thumbnailsByFile: Record<string, string> = {};
  setThumbnailByRootShape(rootShape: RootShape) {
    const IRI = rootShape.IRI;

    // const rc = new RectangleElement(rootShape, this.canvasContainer, {
    //   width: _screenX,
    //   height: _screenY,
    //   fill: '#000000',
    //   noFill: true,
    // }); // -- // -- //

    const thumbnailContainer = new Container();

    // this.canvasContainer.removeChildren(); //
    // this.canvasContainer.addChild(rc.element); //

    // (rootShape as FileRootShape).setThu
    // this.backgroundService.setThumbnailBackgroundByTime(
    //   rootShape.animationStartTime,
    // );

    // (rootShape as FileRootShape).setThumbnailBackground();
    this.backgroundService.setThumbnailById(
      (rootShape.descriptor as FileDescriptor).backgroundDefinitionId,
    );
    thumbnailContainer.addChild(rootShape.backgroundService.thumbnailContainer);
    thumbnailContainer.addChild(rootShape.rootContainer);

    this.setThumbnail(IRI, thumbnailContainer);
    // -- // -- //
    // const canvas = this.app.renderer.extract.canvas(rootShape.rootContainer);
  }

  setCurrentRootShapeThumbnail() {
    console.log('setCurrentRootShapeThumbnail');
    this.setThumbnail(this.currentRootShape.IRI, this.canvasContainer);
  }

  setThumbnail(IRI: string, container: Container) {
    const canvas = this.app.renderer.extract.canvas(container);
    const url = canvas.toDataURL('image/png');

    // -- // -- // console.log('url', url); // -- // -- //
    this.thumbnailsByFile[IRI] = url;
    this.generalEventEmit('thumbnail-updated', IRI);
  }

  thumbnailDataUrl: string;
  thumbnailDataUrls: Record<string, string> = {};
  showFitCanvas = false;
  fitScale: number;
  fitTranslate: Coords;
  controlPanelMouseOver: string;
  mouseOverclear = false;
  diffH: number;

  preFitCanvas() {}
  async fitCanvas(xOffset = 0, retry = false) {
    // if (!this.previewShape) {
    //   return;
    // }

    return new Promise<void>(resolve => {
      // -- // -- // -- //

      const scale = this.canvasWidth / _screenX;

      // -- // -- //
      // console.log('canvasWidth', this.canvasWidth);
      // console.log('canvasHeight', this.canvasHeight);
      // -- // -- //

      // this.previewShape.setScale(scale);

      const currentWidth = scale * _screenX;
      const currentHeight = scale * _screenY;

      this.absoluteCanvasWidth = currentWidth;
      this.absoluteCanvasHeight = currentHeight;

      // console.log('absolute-canvas-width', this.absoluteCanvasWidth); //
      // console.log('absolute-canvas-height', this.absoluteCanvasHeight); //

      const diffW = this.canvasWidth - currentWidth;
      const diffH = this.canvasHeight - currentHeight;

      // if (isNaN(scale) && !retry) {
      //   return setTimeout(() => {
      //     this.fitCanvas(xOffset, true);
      //     resolve();
      //   }, 1000);
      // }
      // console.log('fitCanvas', scale);
      this.fitScale = scale;

      this.generalEventEmit('fit-canvas-updated', scale);
      this.fitTranslate = [0, diffH / 2];
      // this.previewShape.setTranslate(0, diffH / 2);

      // this.rootContainer.position.y = (_screenY / 4) * this.fitScale;
      this.rootContainer.position.y = _screenY / 4;
      // this.previewShape.savePosition();
      // this.previewShape.zoomUpdate();

      this.canvasContainer.scale.x = scale;
      this.canvasContainer.scale.y = scale;

      // console.log('fit-canvas', scale);

      // const next = this.previewShape.next as FileRootShape;
      // if (next) {
      //   next.setScale(scale);
      //   next.setTranslate(0, diffH / 2);
      //   next.savePosition();

      // }

      this.showFitCanvas = false;
      this.generalEventEmit('fitcanvas');
      resolve();
    });
  }

  // get isImageOpened() {
  //   if (!this.previewShape) {
  //     return false;
  //   }
  //   return this.previewShape instanceof ImageShape2;
  // }

  screenRectangle: RectangleElement;
  initScreen(previewShape: RootShape) {
    const canvasWidth = window.innerWidth - 408;
    const canvasHeight = window.innerHeight - 68;
    // -- // -- //

    this.scaleOffset = 1;
    let width: number, height: number;
    // if (previewShape.orientation == 'landscape') {
    //   width = _screenX;
    //   height = _screenY;
    //   if (canvasWidth < _screenX) {
    //     for (let i = 0; i < 10; i++) {
    //       this.scaleOffset /= SCALE_IN;
    //       if (this.scaleOffset * _screenX < canvasWidth) {
    //         // console.log('yooo', this.scaleOffset);
    //         //  console.log('diff', canvasWidth - this.scaleOffset * _screenX);
    //         this.translateOffsetX =
    //           (canvasWidth - this.scaleOffset * _screenX) / 2;
    //         // previewShape._scaleX = this.scaleOffset;
    //         // previewShape._scaleY = this.scaleOffset;
    //         // previewShape.translateX = this.translateOffsetX;
    //         this.canvasContainer.scale.x = this.scaleOffset;
    //         this.canvasContainer.scale.y = this.scaleOffset;
    //         this.canvasContainer.position.x = this.translateOffsetX;
    //         previewShape.redraw();
    //         break;
    //       }
    //     }
    //   } else {
    //     this.translateOffsetX = (canvasWidth - _screenX) / 2;
    //     this.canvasContainer.position.x = this.translateOffsetX;
    //     previewShape.redraw();
    //   }
    // } else {
    //   width = _screenY;
    //   height = _screenX;
    //   if (canvasHeight < height) {
    //     for (let i = 0; i < 10; i++) {
    //       this.scaleOffset /= SCALE_IN;
    //       if (this.scaleOffset * height < canvasHeight) {
    //         // console.log('yooo', this.scaleOffset);
    //         //  console.log('diff', canvasWidth - this.scaleOffset * _screenX);
    //         this.translateOffsetX =
    //           (canvasWidth - this.scaleOffset * _screenY) / 2;
    //         this.canvasContainer.scale.x = this.scaleOffset;
    //         this.canvasContainer.scale.y = this.scaleOffset;
    //         this.canvasContainer.position.x = this.translateOffsetX;
    //         previewShape.redraw();
    //         break;
    //       }
    //     }
    //   } else {
    //     this.translateOffsetX = (canvasWidth - _screenY) / 2;
    //     this.canvasContainer.position.x = this.translateOffsetX;
    //   }
    // }
    this.screenRectangle?.remove();
    // console.log('init-screen', _screenX, _screenY);
    return;
    this.screenRectangle = new RectangleElement(
      previewShape,
      this.canvasContainer,
      // this.app.stage,
      {
        position: {
          x: 1,
          y: 1,
        },
        width: _screenX,
        height: _screenY,
        // fill: '#fff',
        // 'fill-opacity': 0.01,
        noCursorPointer: true,
        // stroke: '#0191f3',
      },
    ).mouseover(() => {
      this.generalEventEmit('canvas-hover');
    });
  }

  adjustSelectedShapes() {
    if (this.selectedShapesStore.length < 2) {
      return;
    }
    // -- // -- // -- //
    const first = this.selectedShapesStore.shift();
    const [w, h] = [first.width, first.height];
    for (const shape of this.selectedShapesStore) {
      shape.resize(w, h);
    }
  }

  toBase64(file: File) {
    return new Promise<APIResponse<string>>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve({ data: reader.result as string });
      reader.onerror = () => resolve({ error: reader.error });
    });
  }

  async saveImageShape() {}
}
